// @flow
import type {Element, Node} from 'react'
import React, {Fragment} from 'react'
import {isEmpty} from 'ramda'

import Alert, {type Severity} from 'components/ui/Alert'

type Props = {
  alertMessage: string,
  alertSeverity: ?Severity,
  children: Node,
  lostChanges: boolean,
}

function WrappedContent({alertMessage, alertSeverity, children, lostChanges}: Props): Element<"div"> {
  return (
    <div className="proposal-summary-wrapped-content">
      <div className="proposal-summary-wrapped-content__alert">
        <Alert
          centered
          message={alertMessage}
          severity={alertSeverity}
        />
      </div>
      {!isEmpty(children) && (
      <Fragment>
        {lostChanges && (
        <div className="proposal-summary-wrapped-content__lost-changes">
          {`${I18n.t('proposal.additional_changes_lost')}: `}
        </div>
        )}
        <div className="proposal-summary-wrapped-content__content">
          {children}
        </div>
      </Fragment>
      )}
    </div>
  )
}

export default WrappedContent
